import React, { FC } from 'react';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import { SxProps } from '@mui/material';
import IconUnchecked from '../../../assets/icons/IconUnchecked';
import IconChecked from '../../../assets/icons/IconChecked';

type CustomCheckboxProps = CheckboxProps & {
  checked: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps;
  icon?: React.ReactNode;
  disabled?: boolean;
};

const CustomCheckbox: FC<CustomCheckboxProps> = ({
  icon,
  checked,
  onChange,
  sx,
  disabled,
}) => {
  return (
    <Checkbox
      checked={checked}
      onChange={onChange}
      sx={sx}
      icon={icon || <IconUnchecked />}
      checkedIcon={<IconChecked />}
      disabled={disabled}
    />
  );
};

export default CustomCheckbox;
